import { uniqueId } from 'lodash';
import { MouseEventHandler, useCallback, useEffect, useState } from 'react';
import { IEmpresas } from '../../interfaces/IEmpresas';
import { IRelatorio } from '../../interfaces/IRelatorio';
import RelatoriosService from '../../services/RelatoriosService';

function CartaoRelatorioAndamentoConta({ title, percent, id, onNext, onPreview } : { title : String, percent : Number, id : String, onNext: MouseEventHandler, onPreview: MouseEventHandler  }) {
    return (
        <div className="card mt-4" style={{ width: '100%', border: '1px solid black' }}>
            <div className="card-body">
                <h5 className="card-title">{title}</h5>
                <p className="card-text">{id} - {percent}%</p>
                <button type="button" className="btn" onClick={onNext}>Avançar</button>
                <button type="button" className="btn" onClick={onPreview}>Voltar</button>
            </div>
        </div>
    )
}

function ColunaRelatorioAndamentoConta({ title, data, onNext, onPreview } : { title: String, data: IRelatorio[] | undefined, onNext: Function, onPreview: Function }) {
    return (
            <div className='col-md-2'>
                <div className='row'>
                    <div className='col-md-12'>
                        <p className='text-center h5'>{title}</p>
                    </div>
                </div>
                <div className='row' style={{ maxHeight: '700px', overflow: 'auto' }}>
                    {data?.map((item) => (
                        <CartaoRelatorioAndamentoConta onNext={() => onNext(item.contaEmpresa, item.status)} onPreview={() => onPreview(item.contaEmpresa, item.status)} id={item.contaEmpresa} percent={0} title={item.descricaoReferencial} key={uniqueId()} />
                    ))}
                </div>
            </div>
    )
}

function RelatorioAndamentoConta({ empresa, dataInicio, dataFim }: { empresa: IEmpresas | undefined, dataInicio: Date | undefined, dataFim: Date | undefined }) {

    const [ordemStatus] = useState<string[]>(['Conciliado Parcial', 'Em Conciliacao', 'Conciliado', 'Documento Suporte', 'Em Conferencia', 'Concluida']);
    const [contas, setContas] = useState<IRelatorio[]>();
    const [esteira, setEsteira] = useState<number>();
    
    const loadDataAll = useCallback((empresaID: number, dataI: Date, dataF: Date, offset: number) => {
        RelatoriosService.dadosResumidos(empresaID || 0, dataI, dataF, offset, (data) => {
            setContas((old) => {
                const value = old || [];
                const newObj = [...value];
                return newObj.concat(data);
            });
            if (data.length > 0) {
                setEsteira(data[0].esteiraID);
            }

            if (data && data.length > 0) {
                loadDataAll(empresaID, dataI, dataF, offset + data.length);
            }
        })
    }, []);

    const avancarStatus = useCallback(async (conta, statusAtual) => {
        const totalStatus = ordemStatus.length;
        const index = ordemStatus.findIndex(item => item === statusAtual)
        if (index >= 0 || !statusAtual) {
            const proximoStatus = !statusAtual ? 1 : index + 1;
            if (proximoStatus <= totalStatus - 1) {
                const status = ordemStatus[proximoStatus];
                await RelatoriosService.updateStatusConta(conta, esteira || 0, status);
                if (dataInicio && dataFim) {
                    loadDataAll(empresa?.id || 0, dataInicio, dataFim, 0);
                }
            }
        }
    }, [ordemStatus, esteira, empresa, dataInicio, dataFim, loadDataAll]);

    const retrocederStatus = useCallback(async (conta, statusAtual) => {
        const index = ordemStatus.findIndex(item => item === statusAtual)
        if (index >= 0) {
            const proximoStatus = index - 1;
            if (proximoStatus >= 0) {
                const status = ordemStatus[proximoStatus];
                await RelatoriosService.updateStatusConta(conta, esteira || 0, status);
                if (dataInicio && dataFim) {
                    loadDataAll(empresa?.id || 0, dataInicio, dataFim, 0);
                }
            }
        }
    }, [ordemStatus, esteira, dataInicio, dataFim, empresa, loadDataAll]);

    useEffect(() => {
        if (empresa && dataInicio && dataFim) {
            loadDataAll(empresa?.id || 0, dataInicio, dataFim, 0);
        }
    }, [empresa, dataInicio, dataFim, loadDataAll])

    return (
        <div className='row mt-5'>
            <ColunaRelatorioAndamentoConta onNext={avancarStatus} onPreview={retrocederStatus} title="Conciliado Parcial" data={contas?.filter(i => i.status === 'Conciliado Parcial' || !i.status)} />
            <ColunaRelatorioAndamentoConta onNext={avancarStatus} onPreview={retrocederStatus} title="Em Conciliação" data={contas?.filter(i => i.status === 'Em Conciliacao')} />
            <ColunaRelatorioAndamentoConta onNext={avancarStatus} onPreview={retrocederStatus} title="Conciliado" data={contas?.filter(i => i.status === 'Conciliado')} />
            <ColunaRelatorioAndamentoConta onNext={avancarStatus} onPreview={retrocederStatus} title="Documento Suporte" data={contas?.filter(i => i.status === 'Documento Suporte')} />
            <ColunaRelatorioAndamentoConta onNext={avancarStatus} onPreview={retrocederStatus} title="Em Conferência" data={contas?.filter(i => i.status === 'Em Conferencia')} />
            <ColunaRelatorioAndamentoConta onNext={avancarStatus} onPreview={retrocederStatus} title="Conciliação Concluía" data={contas?.filter(i => i.status === 'Concluida')} />
        </div>

    );
};

export default RelatorioAndamentoConta;